// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailSignatureTemplateResponse {
    static getAttributeTypeMap() {
        return EmailSignatureTemplateResponse.attributeTypeMap;
    }
}
EmailSignatureTemplateResponse.discriminator = undefined;
EmailSignatureTemplateResponse.additionalProperties = false;
EmailSignatureTemplateResponse.attributeTypeMap = [
    {
        "name": "envelopeId",
        "baseName": "envelopeId",
        "type": "string"
    },
];
//# sourceMappingURL=emailSignatureTemplateResponse.js.map